module.exports = __webpack_public_path__ + "static/img/patho-cerumen-medium-Ct7X8pEe.1e0a1f6a.png";